
const mutation = {
  // 设置用户信息
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_PAGETITLE: (state, title) => {
    state.pageTitle = title
  },
  SET_LOGINSTATUS: (state, loginStatus) => {
    sessionStorage.setItem('loginStatus', loginStatus)
    state.loginStatus = loginStatus
  },
  SER_USERNAME: (state, loginStatus) => {
    sessionStorage.setItem('userInfo', loginStatus)
    state.userName = loginStatus
  }

}
export default mutation



// WEBPACK FOOTER //
// ./src/vuex/modules/user/mutation.js